import men1 from './assets/products/track-pants-men1.webp'
import men2 from './assets/products/track-pants-men2.webp'
import men3 from './assets/products/track-pants-men3.webp'
import men4 from './assets/products/track-pants-men4.webp'
import men5 from './assets/products/track-pants-men5.webp'
import men6 from './assets/products/track-pants-men6.webp'
import men7 from './assets/products/track-pants-men7.webp'
import menT3 from './assets/products/tshirt-men3.webp'
import menT4 from './assets/products/tshirt-men4.webp'
import menHood from './assets/products/hoodie.webp'
import women1 from './assets/products/track-pants-women1.webp'
import women2 from './assets/products/track-pants-women2.webp'
import women4 from './assets/products/track-pants-women4.webp'
import women5 from './assets/products/track-pants-women5.webp'
import women6 from './assets/products/track-pants-women6.webp'
import women7 from './assets/products/track-pants-women7.webp'
import women8 from './assets/products/track-pants-women8.webp'
import women9 from './assets/products/track-pants-women9.webp'
import women10 from './assets/products/track-pants-women10.webp'

export const men=[
    {
        id:'1',
        image:men1,
        title:`Men's Track Pants`
    },
    {
        id:'2',
        image:men2,
        title:`Men's Track Pants`
    },
    {
        id:'3',
        image:men3,
        title:`Men's Track Pants`
    },
    {
        id:'4',
        image:men5,
        title:`Men's Track Pants`
    },
    {
        id:'5',
        image:men4,
        title:`Men's Track Pants`
    },
    {
        id:'6',
        image:men6,
        title:`Men's Track Pants`
    },
    {
        id:'7',
        image:men7,
        title:`Men's Track Pants`
    },
    {
        id:'8',
        image:menT3,
        title:`Men's T-Shirts`
    },
    {
        id:'8',
        image:menT4,
        title:`Men's T-Shirts`
    },
    {
        id:'9',
        image:menHood,
        title:`Men's Hoodie`
    },
]
export const women=[
    {
        id:'1',
        image:women1,
        title:`Women's Track Pants`
    },
    {
        id:'2',
        image:women2,
        title:`Women's Set`
    },
    {
        id:'4',
        image:women4,
        title:`Women's Track Pants`
    },
    {
        id:'5',
        image:women5,
        title:`Women's Track Pants`
    },
    {
        id:'6',
        image:women6,
        title:`Women's Track Pants`
    },
    {
        id:'7',
        image:women7,
        title:`Women's Track Pants`
    },
    {
        id:'8',
        image:women8,
        title:`Women's Gym Set`
    },
    {
        id:'9',
        image:women9,
        title:`Women's Gym Wear`
    },
    {
        id:'10',
        image:women10,
        title:`Women's Gym Wear`
    },
]
